// import {PWMAT_RESOURCE} from './consts'

export const Meet = [{
  name:'1.高性能大尺度原子材料模拟计算面临的挑战与机遇',
  url:'https://v.qq.com/x/page/m3346ilsmbm.html',
  file_name:'纳米结构大体系材料计算'
},
{
  name:'2.大尺度电子结构计算',
  url:'https://www.bilibili.com/video/BV1vd4y1k7oo/?spm_id_from=333.999.0.0&vd_source=0bdf27b8ade1d978776892ded53af857',
  file_name:'用固定电势法发表高影响力论文'
},
]
